/* TCI ADD FILE */

'use strict';

window.addEventListener('load',initCartBenefits);

/**
*
* カートページ初期ロード時に特典を付与する関数
*
*/
async function initCartBenefits() {

  common_show_loding();
  
  const listBenefits =[];
  const updateJsRequestBody = {updates: {}};
  const addJsRequestBody = {items: []};
  let reloadFlg = false;

  if (allBenefits.length !== 0) {
    for (const benefit of allBenefits) {
      
      const totalGrantQuantity = calcGrantQuantityForEachCondition(benefit);
      const variantIdsInCart = benefitsInCart.map(benefit => benefit.variant_id);
  
      if (variantIdsInCart.includes(benefit.variant_id)) {
        const benefitInCart = benefitsInCart.filter(item => item.variant_id === benefit.variant_id);
        if (benefitInCart[0].quantity !== totalGrantQuantity) {
          updateJsRequestBody.updates[benefit.variant_id] = totalGrantQuantity;
        }
        
      } else {
        if (totalGrantQuantity !== 0) {
          const properties = {
            _benefits_type: benefit.product_type
          }
          addJsRequestBody.items.push({id: parseInt(benefit.variant_id),quantity:totalGrantQuantity,properties:properties});
        }
      }
    }

    const allBenefitVariantIds = allBenefits.map(benefit => benefit.variant_id);
    const invalidBenefits = benefitsInCart.filter(benefit => !allBenefitVariantIds.includes(benefit.variant_id));
    if (invalidBenefits.length !== 0) {
      for (const benefit of invalidBenefits) {
        updateJsRequestBody.updates[benefit.variant_id] = 0;
      }
    }

    if (!isEmptyObject(updateJsRequestBody.updates)) {
      const updateJsResult = await fetchPostRequest('/cart/update.js',updateJsRequestBody);
      reloadFlg = updateJsResult ? true : false;
    } else {
      //何もしない
    }
  
    if (addJsRequestBody.items.length !== 0) {
      const addJsResult = await fetchPostRequest('/cart/add.js',addJsRequestBody);
      reloadFlg = addJsResult ? true : false;
    } else {
      //何もしない
    }
    
  } else {

    if (benefitsInCart.length !== 0) {
      for (const benefit of benefitsInCart) {
        updateJsRequestBody.updates[benefit.variant_id] = 0;
        const updateJsResult = await fetchPostRequest('/cart/update.js',updateJsRequestBody);
        reloadFlg = updateJsResult ? true : false;
      }
    }
  }

  if (reloadFlg) {
    location.reload();
  } else {
    common_remove_loding();
  }
  
}
